import { render, staticRenderFns } from "./NowVsFutureTableAB.vue?vue&type=template&id=83871e20&scoped=true&"
import script from "./NowVsFutureTableAB.vue?vue&type=script&lang=js&"
export * from "./NowVsFutureTableAB.vue?vue&type=script&lang=js&"
import style0 from "./NowVsFutureTableAB.vue?vue&type=style&index=0&id=83871e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83871e20",
  null
  
)

export default component.exports